import { render, staticRenderFns } from "./BulkProctor.vue?vue&type=template&id=6651a64b&scoped=true&"
import script from "./BulkProctor.vue?vue&type=script&lang=js&"
export * from "./BulkProctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6651a64b",
  null
  
)

export default component.exports